import { useState, useContext, useEffect, useSelector } from "@/common/hooks";
import { PrivateContext } from "@/routes/PrivateRoute";
import { AgGrid, MobileResponsiveGrid } from "@/common/components";
import { amountFormatter } from "@/utils/Utilities";
import { Heading } from "@/common/components";

const AccountValueByVehicle = () => {
  const { setNavHeader, labels } = useContext(PrivateContext);

  const [rowData, setRowData] = useState();

  const ownershipInquiryResultFromStore = useSelector(
    (state) => state?.ownersReducer?.ownershipInquiryResult
  );
  const asOfBalanceAccountDataFromStore = useSelector(
    (state) => state?.ownersReducer?.asOfBalanceAccountData
  );
  const accountValueDataSourceFromStore = useSelector(
    (state) => state?.ownersReducer?.accountValueDatasource
  );

  useEffect(() => {
    if (accountValueDataSourceFromStore === "currAccountValue") {
      setRowData(
        ownershipInquiryResultFromStore?.productInvestmentVehicleAccount
      );
    } else if (accountValueDataSourceFromStore === "asOfDateAccountValue") {
      setRowData(
        asOfBalanceAccountDataFromStore?.productInvestmentVehicleAccount
      );
    }
  }, [
    accountValueDataSourceFromStore,
    ownershipInquiryResultFromStore,
    asOfBalanceAccountDataFromStore,
  ]);

  const defaultColDef = {
    suppressSizeToFit: true,
    resizable: false,
    sortable: false,
    flex: 1,
    suppressMovable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    wrapText: true,
    autoHeight: true,
  };

  const columnDefs = [
    { headerName: labels?.ownerInquiry?.tradingSymbol, field: "tradingSymbol" },
    {
      headerName: labels?.ownerInquiry?.investmentVehicle,
      field: "vehicleName",
    },
    {
      headerName: labels?.ownerInquiry?.vehicleValue,
      field: "accountValue",
      cellRenderer: amountFormatter,
    },
    { headerName: labels?.ownerInquiry?.tdf, field: "isTargetFund" },
    { headerName: labels?.ownerInquiry?.active, field: "isActiveTargetFund" },
    {
      headerName: labels?.ownerInquiry?.activationDate,
      field: "targetFundActivationDate",
    },
  ];

  useEffect(() => {
    setNavHeader(labels?.ownerInquiry?.title);
  }, []);
  return (
    <section className="container-large py-5">
      <Heading
        text={labels?.ownerInquiry?.accValueByVehicle}
        title={false}
        wrapperClassNames="h4 mb-4 text-center"
      />
      <AgGrid
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        rowData={rowData}
        wrapperClassNames="mb-5 d-none d-md-block"
        domLayout="normal"
      />
      <MobileResponsiveGrid
        key="accountValueByVehicle"
        rowData={rowData}
        columnDefs={columnDefs}
      />
    </section>
  );
};

export default AccountValueByVehicle;
